import { styled } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";

const Home = () => {
  return (
    <HomeWrapper>
      <CardMediaWrapper>
        <CardMedia component='img' image='/images/welcome.jpg' alt='welcome' />
      </CardMediaWrapper>
    </HomeWrapper>
  );
};

export default Home;

const HomeWrapper = styled("div")`
  display: flex;
  height: 90vh;
  justify-content: center;
  align-items: center;
`;

const CardMediaWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 60%;
`;
